import { render, staticRenderFns } from "./Terminar.vue?vue&type=template&id=589cbafa"
import script from "./Terminar.vue?vue&type=script&lang=js"
export * from "./Terminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports